module.exports = __webpack_public_path__ + "img/Flag_of_Panama.9f5f81f0.svg";